import { common } from "../common/index.mjs.mjs";
import { colors } from "./audi-colors.mjs.mjs";
import { shadow } from "./audi-shadows.mjs.mjs";
export const audiDarkTheme = {
    ...common,
    name: 'Audi Dark Theme',
    colors,
    shadow,
};
//# sourceMappingURL=audi-dark.theme.mjs.mjs.map